<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    width="1000px"
     v-dialogDrag
     @close="colseDialog"
    :visible.sync="visible">
    <el-button v-if="method != 'add'" size="medium" class="mb8"  :icon="method == 'view' ? 'el-icon-edit' :''"
     :type="method == 'view' ? 'warning' :'primary'"  :plain="method == 'view' ? false : true"
     @click="handEditorView(method)" :disabled="!hasPermission('unmcontactus:cecUnmContactUs:edit')">
      {{ method == 'view' ? '编辑' : '取消'}}
     </el-button>
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="150px">
      <el-row  :gutter="15" type="flex" style="flex-wrap:wrap">
        <el-col :span="12" v-if="formType == '1'">
            <el-form-item label="姓" prop="firstName"
                :rules="[
                  {required: true, message:'姓不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.firstName" :disabled="usersInput" placeholder="请填写姓"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formType == '1'">
            <el-form-item label="名" prop="lastName"
                :rules="[
                  {required: true, message:'名不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.lastName" :disabled="usersInput" placeholder="请填写名"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="邮箱" prop="email"
                :rules="[
                  {required: true, message:'邮箱不能为空', trigger:'blur'},
                  {type: 'email', message:'请输入有效的邮箱！', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.email" :disabled="usersInput" placeholder="请填写邮箱"  maxlength="64"   v-trim ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formType == '2'">
            <el-form-item label="联系电话" prop="phone"
                :rules="[
                  {required: true, message:'联系电话不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.phone" :disabled="usersInput" placeholder="请填写联系电话"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formType == '2'">
            <el-form-item label="全称" prop="fullName"
                :rules="[
                  {required: true, message:'全称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.fullName" :disabled="usersInput" placeholder="请填写全称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formType == '2'">
            <el-form-item label="项目类型" prop="projectTypeName"
                :rules="[
                  {required: true, message:'项目类型不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.projectTypeName" :disabled="usersInput" placeholder="请填写项目类型"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formType == '2'">
            <el-form-item label="期望项目开始日期" prop="projectStartTimeName"
                :rules="[
                  {required: true, message:'期望项目开始日期不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.projectStartTimeName" :disabled="usersInput" placeholder="请填写期望项目开始日期"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formType == '2'">
            <el-form-item label="项目预算" prop="projectBudgetName"
                :rules="[
                  {required: true, message:'项目预算不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.projectBudgetName" :disabled="usersInput" placeholder="请填写项目预算"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="用户ip" prop="ipAddress"
                :rules="[
                 ]">
            <el-input :disabled="usersInput"  v-model="inputForm.ipAddress" placeholder="请填写用户ip"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formType == '2'">
            <el-form-item label="客户填写时间" prop="createDate"
                :rules="[
                  
                 ]">
              <el-input v-model="inputForm.createDate" :disabled="usersInput" placeholder="请填写客户填写时间"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="信息" prop="message"
                :rules="[
                 ]">
          <el-input type="textarea" :disabled="usersInput" rows="5" v-model="inputForm.message" placeholder="请填写信息"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="处理情况" prop="status"
                :rules="[
                  {required: true, message:'处理情况不能为空', trigger:'blur'}
                 ]">
                 <el-radio-group v-model="inputForm.status">
                  <el-radio :label="item.value" v-for="item in $dictUtils.getDictList('cec_status')" :key="item.id">{{ item.label }}</el-radio>
                </el-radio-group>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="内部备注" prop=""
                :rules="[
                 ]">
            <el-input type="textarea" rows="5" v-model="inputForm.remarks" placeholder="请填写内部备注"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formType == '2'">
            <el-form-item label="发送邮件给客户" prop=""
                :rules="[
                 ]">
             <el-button size="small" type="primary" icon="el-icon-message" @click="sendEmailForCustomer(inputForm.id)" v-noMoreClick>发送邮件</el-button>
           </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formType == '2'">
            <span>上一次发送邮件时间：</span>
             <span>{{ inputForm.sendEmailTime }}</span>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" type="danger"  icon="el-icon-close" @click="visible = false">关闭</el-button>
      <el-button size="medium" type="success" icon="el-icon-check" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmContactUsService from '@/api/unmcontactus/cecUnmContactUsService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        usersInput: true,
        formType: '1',
        inputForm: {
          id: '',
          firstName: '',
          lastName: '',
          email: '',
          message: '',
          remarks: '',
          ipAddress: '',
          status: '',
          sendEmailTime: '',
          fullName: '',
          projectTypeName: '',
          projectStartTimeName: '',
          projectBudgetName: '',
          phone: '',
          ip: ''
        }
      }
    },
    components: {
    },
    methods: {
      // 切换编辑状态
      handEditorView (method) {
        this.method = method === 'view' ? 'edit' : 'view'
      },
      init (method, data) {
        this.method = method
        this.inputForm.id = data.id
        this.formType = data.type
        if (method === 'add') {
          this.title = `新建联系我们管理`
        } else if (method === 'edit') {
          this.title = '修改联系我们管理'
        } else if (method === 'view') {
          this.title = data.type === '1' ? '查看联系我们管理' : '查看免费设计咨询'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            // cecUnmContactUsService.queryById(this.inputForm.id).then(({data}) => {
            //   this.inputForm = this.recover(this.inputForm, data)
            //   this.loading = false
            // })
            this.getQueryById()
          }
        })
      },
      getQueryById () {
        cecUnmContactUsService.queryById(this.inputForm.id).then(({data}) => {
          this.inputForm = this.recover(this.inputForm, data)
          this.loading = false
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmContactUsService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      },
      sendEmailForCustomer (cid) {
        this.loading = true
        cecUnmContactUsService.sendEmailForCustomer(this.inputForm).then(({data}) => {
          this.getQueryById()
          this.$message.success(data)
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      colseDialog () {
        this.$emit('refreshDataList')
      }
    }
  }
</script>
<style scoped>
::v-deep .el-dialog__body{
 padding: 10px 20px !important;
}
</style>
  
